exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerArrow {\n    font-size: .75em;\n}\n\n.toggle {\n    width:100%;\n}\n\n.toggleContainer {\n    cursor: pointer;\n    cursor : hand;\n}\n", ""]);

// exports
